import dayjs from '../../dayjs';

/**
 * @description: 根据年份获季度的date信息
 * @param {number} year
 * @return {*}
 */
export function getSeasonDateByYear(year: number) {
  const seasonAry: any[] = []
  for (let i = 0; i < 4; i++) {
    const start = dayjs().year(year).set('month', i * 3).set('date', 1)
    const end = dayjs().year(year).set('month', (i + 1) * 3).set('date', 0)
    seasonAry.push({
      start: new Date(+start),
      end: new Date(+end),
      seasonNumber: i + 1,
      season: `${year}-Q${i + 1}`
    })
  }
  return seasonAry
}